import ChartPDFParametersFormattingStrategy from './ChartPDFParametersFormattingStrategy'
import ChartPDFDateRangeFormattingStrategy from '../../../../pdf/formatters/ChartPDFDateRangeFormattingStrategy'

export default class ChartPDFLeaveParametersFormattingStrategy extends ChartPDFParametersFormattingStrategy {
    init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
        super.init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor)
        return this
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        return new ChartPDFDateRangeFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters) {
        return {
            firstRow: this.parametersFormatter.formatUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
            secondRow:  this.parametersFormatter.formatLeaveTypesSelection(selectedParameters.hierarchicalSelectorsParameters.leaveTypeSelection)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/formatters/ChartPDFLeaveParametersFormattingStrategy.js